import { Helmet } from 'react-helmet';
import QuetdatakhonggoiDetail
  from 'src/components/quetdatakhonggoi-detail/QuetdatakhonggoiDetail';
  import UploadListToolbar from 'src/components/quetdatakhonggoi-detail/UploadListToolbar';
import {
  Box,
  Container,
} from '@material-ui/core';

const Quetdatakhonggoi = () => (
  <>
    <Helmet>
      <title>Quét data không gói</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
      <UploadListToolbar />
        <Box sx={{ pt: 3 }}>
          <QuetdatakhonggoiDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Quetdatakhonggoi;
